import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { enableAutosave } from '../../redux/actions/general/autosave';
import { __, getLocalized, mapStateToProps } from '../../core/utils';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import Select from '../../components/Select';
import styles from '../../styles/forms/boq/BOQForm.scss';
import { listPossibleResponsibleSpecificationTeams } from '../../redux/actions/table/working_set_specifications';
import Input from '../../components/Input';

@reduxForm({
  form: 'working_set_boq.boq',
  enableReinitialize: true,
})
@subscribe(Localization, 'localization')
@mapStateToProps((state) => ({
  store: state.table.working_set_boq,
}))
class QuantityForm extends Component {
  static defaultProps = {
    editable: true,
  };

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  render() {
    const { handleSubmit, editable, language_id } = this.props;

    const installation_types = [
      { value: 'OFCI', label: 'OFCI' },
      { value: 'OFOI', label: 'OFOI' },
      { value: 'CFCI', label: 'CFCI' },
      { value: 'CFOI', label: 'CFOI' },
    ];

    const budget_types = [
      { value: 'FF&E', label: 'FF&E' },
      { value: 'OS&E', label: 'OS&E' },
      { value: 'CAPEX', label: 'CAPEX' },
    ];

    const boq_supply_type_groups = _.sortBy(
      _.map(this.props.localization.boq_supply_type_groups, (unit) => ({
        label: getLocalized(unit.name, language_id),
        value: unit.id,
        tooltip: getLocalized(unit.name, language_id),
        priority: _.get(this.props.localization.boq_supply_type_groups, [
          unit.boq_supply_type_group_id,
          'priority',
        ]),
      })),
      'priority'
    );

    const units = _.sortBy(
      _.map(this.props.localization.units, (unit) => ({
        label: unit.symbol,
        value: unit.id,
        tooltip: unit.description,
        group: _.get(this.props.localization.unit_groups, [
          unit.unit_group_id,
          'name',
          1,
        ]),
        groupPriority: _.get(this.props.localization.unit_groups, [
          unit.unit_group_id,
          'priority',
        ]),
      })),
      'groupPriority'
    );

    return (
      <Form onSubmit={handleSubmit}>
        <div className={styles.flex}>
          <div className={styles.f2} />
          <div className={styles.f1}>
            <Field
              name='price'
              component={Input}
              label={__('boq.boq-form.price')}
              maxLength={50}
              numeric
              decimal
            />
          </div>
          <div className={styles.f1}>
            <Field
              disabled={!editable}
              name='unit_id'
              component={Select}
              label={__('boq.boq-form.unit')}
              searchable
              options={units}
              noSort
            />
          </div>
        </div>

        <div className={styles.flex}>
          <div className={styles.f1}>
            <Field
              name='budget_type'
              component={Select}
              label={__('boq.boq-form.budget_type')}
              searchable
              options={budget_types}
              noSort
            />
          </div>
          <div className={styles.f1}>
            <Field
              name='installation_type'
              component={Select}
              label={__('boq.boq-form.installation_type')}
              searchable
              options={installation_types}
              noSort
            />
          </div>

          <div className={styles.f1}>
            <Field
              name='boq_supply_type_group_id'
              component={Select}
              label={__('boq.boq-form.boq_supply_type_group')}
              searchable
              options={boq_supply_type_groups}
              noSort
            />
          </div>
        </div>
      </Form>
    );
  }
}

export default QuantityForm;
